var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamationCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.11719C5.16797 2.11719 1.25 6.03516 1.25 10.8672C1.25 15.6992 5.16797 19.6172 10 19.6172C14.832 19.6172 18.75 15.6992 18.75 10.8672C18.75 6.03516 14.832 2.11719 10 2.11719ZM10 18.1328C5.98828 18.1328 2.73438 14.8789 2.73438 10.8672C2.73438 6.85547 5.98828 3.60156 10 3.60156C14.0117 3.60156 17.2656 6.85547 17.2656 10.8672C17.2656 14.8789 14.0117 18.1328 10 18.1328Z",
    fill: "black",
    fillOpacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53125 12.1172H10.4688C10.5547 12.1172 10.625 12.0469 10.625 11.9609V6.64844C10.625 6.5625 10.5547 6.49219 10.4688 6.49219H9.53125C9.44531 6.49219 9.375 6.5625 9.375 6.64844V11.9609C9.375 12.0469 9.44531 12.1172 9.53125 12.1172ZM9.0625 14.3047C9.0625 14.5533 9.16127 14.7918 9.33709 14.9676C9.5129 15.1434 9.75136 15.2422 10 15.2422C10.2486 15.2422 10.4871 15.1434 10.6629 14.9676C10.8387 14.7918 10.9375 14.5533 10.9375 14.3047C10.9375 14.056 10.8387 13.8176 10.6629 13.6418C10.4871 13.466 10.2486 13.3672 10 13.3672C9.75136 13.3672 9.5129 13.466 9.33709 13.6418C9.16127 13.8176 9.0625 14.056 9.0625 14.3047Z",
    fill: "black",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationCircle);
export default __webpack_public_path__ + "static/media/exclamation-circle.22c994c425080c5a541468e9af50a779.svg";
export { ForwardRef as ReactComponent };